import {ValidationErrors, ValidatorFn} from "@angular/forms";
import {PasswordCondition} from "./passwords-conditions";


export class PasswordValidator {

	constructor(private conditions: PasswordCondition[]) {
	}

	validate(): ValidatorFn {
		const conditions = this.conditions;
		return control => {
			const notMetConditions: PasswordCondition[] = control.value == null ?
				conditions.concat([]) :
				conditions.filter(condition => !condition.matches(control.value));

			return notMetConditions.map(condition => {
				const errors: ValidationErrors = {};
				errors[condition.type()] = condition.type();
				return errors;
			}).reduce((previous, current) => Object.assign(previous, current), {} as ValidationErrors);
		};
	}
}
